export function PartialInvoiceUpdater() {
    return [
        {
            field: 'isFixedAmount',
            updates: () => {
                return {
                    amount: null,
                };
            },
        },
    ];
}
